import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class AirlineService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('airline/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('airline/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('airline/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('airline/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('airline/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('airline/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('airline/delete', val_id);
  }
}
